/*
 * @Author: Zhouqi
 * @Date: 2025-12-25 16:55:11
 * @LastEditors: Zhouqi
 * @LastEditTime: 2026-02-12 15:09:42
 */
const initShence = async () => {
  if (typeof window !== 'undefined' && !window['sensorsDataAnalytic201505']) {
    const sensors = (await import('sa-sdk-javascript')).default;
    sensors.init({
      server_url: 'https://su-usa.falcocut.ai/sa?project=BoomCut',
      is_track_single_page: true, // 单页面配置，默认关闭。开启后自动监听 URL 有变化就会触发 $pageview 事件
      use_client_time: true,
      send_type: 'beacon',
      // show_log: true,
      heatmap: {
        //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
        clickmap: 'default',
        //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
        scroll_notice_map: 'not_collect',
      },
    });
    sensors.quick('autoTrack'); //用于采集 $pageview 事件。
    return sensors;
  }
  return window['sensorsDataAnalytic201505'];
};

export default initShence;
